import { IdTitle, IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { ApplicationPermissionType } from "ui/Scripts/source/models/enums";
import { Base } from "ui/Scripts/source/framework/base";

export interface ISavedPrint extends IIdTitle {
    applicationPermissionType: ApplicationPermissionType;
    defaultPrint: boolean;
    fields: string[];
    spacer: boolean;

    getHash(): string;
    isNew(): boolean;
}

export class SavedPrint extends IdTitle implements ISavedPrint {
    applicationPermissionType: number;
    defaultPrint: boolean;
    fields: string[];
    spacer: boolean;

    constructor();
    constructor(obj: ISavedPrint);
    constructor(obj?: any) {
        super(obj);
        this.applicationPermissionType = obj && obj.applicationPermissionType || ApplicationPermissionType.Message;
        this.defaultPrint = obj && obj.defaultPrint || false;
        this.fields = obj && obj.fields || [];
        this.spacer = obj && obj.spacer || false;
    }

    getHash(): string {
        return super.getHash() + "#" + this.applicationPermissionType.toString(10) + "#" + this.defaultPrint.toString() + "#" + JSON.stringify(this.fields);
    }

    isNew(): boolean {
        return !this.id;
    }
    
    static createSpacer(): ISavedPrint {
        const result = new SavedPrint();
        result.id = Base.getGuid();
        result.spacer = true;
        return result;
    }

    static sortSavedPrints(items: ISavedPrint[]): ISavedPrint[] {
        if (!items && items.length < 2) return items;
        return items.sort((a: ISavedPrint, b: ISavedPrint) => {
            if (!a || !b) return 0;
            if (a.defaultPrint !== b.defaultPrint) return Base.boolCompare(a.defaultPrint, b.defaultPrint);
            return Base.strCompare(a.getTitle(), b.getTitle());
        });
    }
}